var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex flex-grow flex-col items-center justify-center w-full h-full"
    },
    [
      _c("BaseIcon", {
        staticClass: "w-48 h-48 mb-4",
        attrs: { name: "media-kraken-confused" }
      }),
      _c("h2", { staticClass: "text-2xl text-center font-semibold" }, [
        _vm._v(" " + _vm._s(_vm.crashReport.title) + " ")
      ]),
      _vm.crashReport.subtitle
        ? _c("p", { staticClass: "mt-1 text-sm text-gray-700 text-center" }, [
            _vm._v(" " + _vm._s(_vm.crashReport.subtitle) + " ")
          ])
        : _vm._e(),
      _c("p", { staticClass: "my-4" }, [
        _vm._v(" Here are some things you can do: ")
      ]),
      _c(
        "div",
        { staticClass: "flex flex-col" },
        _vm._l(_vm.actions, function(action, i) {
          return _c(
            "BaseButton",
            {
              key: i,
              staticClass:
                "border border-primary-500 text-sm text-primary-700 justify-center mb-2 hover:bg-black-overlay",
              on: { click: action.handle }
            },
            [_vm._v(" " + _vm._s(action.label) + " ")]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }